import styled from 'styled-components';
import { DefaultButton } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const SurveyModalBlackBG = styled.div`
  position: fixed;
  overflow: auto;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba(45, 45, 45, 0.7);
`;

export const SurveyModalCont = styled.div`
  width: 768px;
  min-height: 100px;
  z-index: 2000;
  position: absolute;
  top: 5%;
  left: 0;
  right: 0;
  margin: 0 auto;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[5]};
  `};
`;

export const SurveyModalHeader = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 72px;
  width: 100%;
  ${({ theme }: IThemeProvider) => `
       padding: 0 ${theme.layout.spacing.decy};
       border-width:  0 0 1px 0;
       border: 1px solid ${theme.colors.neutral.primary[30]};
      border-width: 0 0 1px 0;
    `};
`;

export const CloseMarkCont = styled.div`
  position: absolute;
  cursor: pointer;
  right: 24px;
  top: 24px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    height: 24px;
  }
`;

export const SurveyModalBody = styled.div`
  display: flex;
  height: fit-content;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 32px 48px 32px 32px;
`;

export const SurveyModalFooter = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  box-sizing: border-box;
  height: 80px;
  ${({ theme }: IThemeProvider) => `
       padding: 0 ${theme.layout.spacing.centy};
       border: 1px solid ${theme.colors.neutral.primary[30]};
       border-width: 1px 0 0 0;
    `};
`;

export const CreateButton = styled(DefaultButton)`
  border-radius: 8px;
  text-transform: capitalize;
  width: auto;
  border: none;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.primary[100]};
    margin: 0 0 0 ${theme.layout.spacing.centy};
    padding:  0 ${theme.layout.spacing.centy} 0 ${theme.layout.spacing.centy};
    color: ${theme.colors.neutral.primary[5]};
  `};
`;

export const CancelButton = styled(CreateButton)`
  display: flex;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
    border: 2px solid ${theme.colors.primary[100]};
    color: ${theme.colors.primary[100]};
  `};
`;

export const CloseMarkOnCancelCont = styled.div`
  width: 20px;
  height: 20px;

  ${({ theme }: IThemeProvider) => `
    svg {
      width: 20px;
      height: 19px;

      path {
        fill: ${theme.colors.primary[100]};
      }
    }
  `}
`;
